import React from "react";
import { Container, Row, Col } from "reactstrap";
import { ChevronLeft, ChevronsRight, Circle } from "react-feather";

const PRIMARY_TEXT_COLOR = "#000"; // 
const PrivacyPolicy = () => {
  const bullet = (
    <strong className="pr-2">
      <Circle size={6} fill={PRIMARY_TEXT_COLOR} />
    </strong>
  );
  const subBullet = (
    <strong className="pr-2">
      <ChevronsRight size={16} fill={PRIMARY_TEXT_COLOR} />
    </strong>
  );

  const PolicyStyles = () => (
    <style>{`
      // h5 {
      //   font-size: 1.8rem;
      //   font-weight: 700;
      //   text-align: center;
      //   border-bottom: 2px solid #000;
      //   padding-bottom: 0.4rem;
      // }

      p, li {
        font-size: 1rem;
        line-height: 1.7;
        color:rgb(71, 77, 106);
      }

      ul, ol {
        padding-left: 1.2rem;
        margin-top: 0.5rem;
        margin-bottom: 1rem;
      }

      @media (max-width: 576px) {
        h5 {
          font-size: 1.4rem;
        }
        p, li {
          font-size: 0.95rem;
        }
      }
    `}</style>
  );

  return (
    <Container fluid className="py-5 px-3 px-md-5" style={{color:"rgb(71, 77, 106)"}}>
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <PolicyStyles />
          <div className="py-4 px-2 d-flex justify-content-center">
            <h5 className="headingMainStyle">
              <span>Privacy Policy</span>
            </h5>
          </div>
          <p><strong>Dated: 18th June 2025</strong></p>
          <p className="mb-4">
            Welcome to <strong>BetelJobs!</strong> We respect your privacy and are committed to protecting your personal information.
            This Privacy Policy explains how we collect, use, share, and safeguard your information when you use our website and services.
          </p>

          <ol>
            <li>
              <strong>Information We Collect</strong>
              <p>We collect the following types of information to provide and improve our services:</p>
              <ul>
                <li><strong>a. Personal Information</strong></li>
                <ul>
                  <li>{bullet} Name, email address, phone number, and mailing address.</li>
                  <li>{bullet} Professional information such as qualifications, certifications, work experience, and references.</li>
                  <li>{bullet} Payment details for subscription-based services.</li>
                </ul>
                <li><strong>b. Non-Personal Information</strong></li>
                <ul>
                  <li>{bullet} Browser type, operating system, and device information.</li>
                </ul>
                <li><strong>c. Job Application Data</strong></li>
                <ul>
                  <li>{bullet} Resumes, cover letters, and supporting documents submitted for job applications.</li>
                </ul>
                <li><strong>d. Third-Party Data</strong></li>
                <ul>
                  <li>{bullet} Information from LinkedIn or other platforms if linked to your account.</li>
                  <li>{bullet} Cookies and other tracking for better user interface.</li>
                </ul>
                <li><strong>e. Basis of collection of the data</strong></li>
                <ul>
                  <li>{subBullet} Consent</li>
                  <li>{subBullet} Legal obligation</li>
                </ul>
              </ul>
            </li>

            <li>
              <strong>How We Use Your Information</strong>
              <ul>
                <li>{bullet} Facilitating job searches and applications.</li>
                <li>{bullet} Matching candidates with suitable employers.</li>
                <li>{bullet} Improving website functionality and user experience.</li>
                <li>{bullet} Sending account updates, job alerts.</li>
                <li>{bullet} Processing payments and subscriptions.</li>
                <li>{bullet} Resolving queries.</li>
                <li>{bullet} Detecting and preventing any illegal activities by applicants.</li>
                <li>{bullet} Identity verification, government sanctions screening, and due diligence checks.</li>
              </ul>
            </li>

            <li>
              <strong>Sharing Your Information and Disclosure</strong>
              <ul>
                <li>{bullet} <strong>Employers and Recruiters:</strong> To facilitate job applications.</li>
                <li>{bullet} <strong>Service Providers:</strong> For hosting, payments, and email services.</li>
                <li>{bullet} <strong>Legal Authorities:</strong> As required by law or to protect legal rights.</li>
                <li>{bullet} <strong>Third-Party Integrations:</strong> With your consent (e.g., LinkedIn).</li>
                <li><strong>Note:</strong> We do not sell your personal data to third parties.</li>
              </ul>
            </li>

            <li>
              <strong>Data Security</strong>
              <p>We use industry-standard measures like encryption and secure servers to protect your data.</p>
              <p>However, no method is 100% secure. Data shared may be used for:</p>
              <ul>
                <li>{bullet} Lawful processing</li>
                <li>{bullet} Security safeguards</li>
                <li>{bullet} Data fiduciary responsibility</li>
                <li>{bullet} Transparency</li>
              </ul>
              <p>
                For disputes related to data security, <strong>provisions of DPDPA 2023</strong> apply.
              </p>
            </li>

            <li>
              <strong>Your Rights</strong>
              <ul>
                <li>{bullet} Access and Correction</li>
                <li>{bullet} Data Deletion</li>
                <li>{bullet} Withdraw Consent</li>
                <li>{bullet} Data Portability</li>
                <li>{bullet} Restrict Processing</li>
                <li>{bullet} File Complaints or Grievances</li>
              </ul>
              <p>Contact us at <strong>support@beteljobs.com</strong> to exercise these rights.</p>
            </li>

            <li>
              <strong>Third-Party Links</strong>
              <p>
                Our site may contain links to third-party websites. We are not responsible for their privacy practices. Please review their policies before sharing any data.
              </p>
            </li>

            <li>
              <strong>Changes to This Policy</strong>
              <p>
                We may update this Privacy Policy periodically. Changes will be posted here and notified through email or our website.
              </p>
              <p>Updates are governed by the <strong>IT Act 2000</strong>.</p>
            </li>

            <li>
              <strong>Contact Us</strong>
              <p>
                For questions or concerns, reach us at:<br />
                <strong>Email:</strong> support@beteljobs.com
              </p>
              <p>By using BetelJobs.com, you agree to this Privacy Policy.</p>
            </li>

            <li>
              <strong>Disclaimer</strong>
              <p>
                BetelJobs never asks for personal or monetary information beyond required platform fees. Any loss due to external fraud is solely the candidate’s responsibility.
              </p>
            </li>

            <li>
              <strong>Legal Framework</strong>
              <p>
                We comply with provisions of the <strong>IT Act 2000</strong> and <strong>DPDPA Act 2023</strong>.
              </p>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
